module.exports = __webpack_public_path__ + "img/news-title-md.849f563f.png";